<div class="btn-events-one">
  <a (click)="onClick()">
    <div class="art-box">
      <div>
        <div>
        <h2 *ngIf="title" class="{{fontSizeClass}}">{{ title | translate }}</h2>
          <h3 *ngIf="date" [innerHTML]="date"></h3>
          <h4 *ngIf="slotTime" [innerHTML]="slotTime"></h4>
          <h4 *ngIf="amount" [innerHTML]="amount"></h4>
          <h4 class="available-quantity">{{ freeQuantity }} {{ "Tickets left" | translate }}</h4>
          <p>
          </p>
        </div>
      </div>
    </div>
  </a>
</div>
